import { PropsWithChildren } from 'react'
import { ThemeProvider } from 'styled-components'

import { GlobalStyle } from '@/styles/globalStyles.tsx'
import { velthuis, xpert } from '@/styles/theme'
import { isVelthuis } from '@/utils/common.ts'

export const Providers = ({ children }: PropsWithChildren) => {
  return (
    <ThemeProvider theme={isVelthuis ? velthuis : xpert}>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  )
}
